<template>
  <div class="contact_wrapper pointer" @click="showtoggle = false" :class="`contact-${device}`" v-if="showtoggle">
    <div class="content">
      <div class="title">简历投递</div>
      <div class="email">投递邮箱：{{info.hr_email}}</div>
      <div class="img">
        <img :src="info.hr_qr_code" alt="" />
      </div>
      <div class="desc">扫一扫上面的二维码图案，联系HR</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showtoggle: false,
      info:{}
    };
  },
  created(){
      this.getSetting()
  },
  methods:{
      getSetting(){
          this.$api.getSetting().then(res=>{
              this.info = res.data.global_config;
          })
      }
  }
};
</script>

<style lang="less" scoped>
.contact-pc {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba((0), 0, 0, 0.5);
  z-index: 100000;
  display: flex;
  align-items: center;
  justify-content: center;
  .content {
    background: #fff;
    display: flex;
    border-radius: 10px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 400px;
    .title {
      height: 60px;
      display: flex;
      align-items: center;
      margin: 0 10px;
      font-size: 20px;
      width: 380px;
      text-align: center;
      justify-content: center;
      border-bottom: 1px solid #f98987;
    }
    .email {
      font-size: 16px;
      margin: 15px 0;
    }
    .img {
      img {
        width: 300px;
      }
    }
    .desc {
      font-size: 16px;
      margin: 15px 0;
    }
  }
}
.contact-mobile {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba((0), 0, 0, 0.5);
  z-index: 100000;
  display: flex;
  align-items: center;
  justify-content: center;
  .content {
    background: #fff;
    display: flex;
    border-radius: .1333rem;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 5.3333rem;
    .title {
      height: .8rem;
      display: flex;
      align-items: center;
      margin: 0 .1333rem;
      font-size: .2667rem;
      width: 5.0667rem;
      text-align: center;
      justify-content: center;
      border-bottom: .0133rem solid #f98987;
    }
    .email {
      font-size: .2133rem;
      margin: .2rem 0;
    }
    .img {
      img {
        width: 4rem;
      }
    }
    .desc {
      font-size: .2133rem;
      margin: .2rem 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/contact.vue